import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function BaiduAnalytics() {
  const location = useLocation();
  const isFirst = useRef(true);

  useEffect(() => {
    const hm = (window as unknown as { _hmt?: unknown[] })._hmt;
    if (!Array.isArray(hm)) return;

    // 首次进入由 hm.js 自动上报 PV，跳过以避免重复统计
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }

    const path = window.location.pathname + window.location.search;
    hm.push(['_trackPageview', path]);
  }, [location.pathname, location.search]);

  return null;
}